import {
    IAnalyticsLibrary,
    IRWCAnalyticsLibrary,
} from '@ringcentral/rwc-utils/src/analytics/types';
import getConfig from '../config';
import { getPrefixedLogger, prefixes } from '../rwc-logger';
import { isApplication, OS_INFO } from '../client-detection';
import { FEATURE_FLAGS } from '../constants/feature-flags';
import { featureFlagClient } from '../feature-flag-client';
import { AnalyticsLibrary } from './analytics-library';

export const logger = getPrefixedLogger(prefixes.VC_UTILS, 'analytics');

export const baseProps = {
    // RC analytics department requires `endPoint` property to present in every event for consistency,
    // as it's sent by other RC applications too.
    // For internal RCV analysis the appType and OS (auto determined by mixpanel) properties can be used.
    endPoint: isApplication() ? OS_INFO : `${OS_INFO}:web`,
    version: '',
};

let _analyticsLibraryInstance: IAnalyticsLibrary | IRWCAnalyticsLibrary | null;

export function getAnalyticsInstance(v?: string): IAnalyticsLibrary | IRWCAnalyticsLibrary | null {
    const mixpanelWriteKey = getConfig('MIXPANEL')?.WRITE_KEY;
    const mixpanelSettings = getConfig('MIXPANEL')?.SETTINGS;
    const isMixpanelEnabled = Boolean(featureFlagClient.getFlag(FEATURE_FLAGS.mixpanel)?.enabled);
    const isAnalyticsEnabled = Boolean(isMixpanelEnabled && mixpanelWriteKey);

    if (!isAnalyticsEnabled) {
        return null;
    }
    if (v && baseProps.version === '') {
        baseProps.version = v;
    }

    if (_analyticsLibraryInstance === undefined) {
        try {
            _analyticsLibraryInstance = new AnalyticsLibrary(
                mixpanelWriteKey as string,
                mixpanelSettings as Record<string, unknown>
            );
        } catch (error) {
            _analyticsLibraryInstance = null;
            logger.error('Analytics initialization error', error);
        }
    }

    return _analyticsLibraryInstance;
}
